import NextLink from "next/link";
import { Trans, useTranslation } from "react-i18next";
import styles from "@/components/Link/index.module.css";
import { pushContactClick } from "@/utils/dataLayer";

interface ContactLinkProps {
  href: string | string[];
  i18nKey: string;
}

const ContactLink = ({ href, i18nKey }: ContactLinkProps) => {
  const [namespace, key] = i18nKey.includes(":") ? (i18nKey.split(":") as [string, string]) : ["common", i18nKey];
  const { t } = useTranslation(namespace as Parameters<typeof useTranslation>[0]);

  const hrefs = Array.isArray(href) ? href : [href];

  const components = Object.fromEntries(
    hrefs.map(contactHref => {
      const isEmail = contactHref.startsWith("mailto:");
      const contactType = isEmail ? "Email" : "Phone";
      const contactText = contactHref.replace(/^(mailto:|tel:)/, "");
      const componentKey = isEmail ? "mail" : "phone";

      return [
        componentKey,
        <NextLink
          key={componentKey}
          href={contactHref}
          className={styles.link}
          onClick={() => pushContactClick(contactType, t(key), contactText)}
        />,
      ];
    })
  );

  return <Trans t={t} i18nKey={key} components={components} />;
};

export default ContactLink;
